import Router from 'vue-router'
export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/views/login/index.vue'], resolve)
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js